export default "__VITE_ASSET__DaVj7Izw__";